export default __webpack_public_path__ + "static/media/logout.1e0a3cd8.svg";